import { useQuery } from '@tanstack/react-query';
import {
  getProductReviewByVendorId,
  ProductReviewDetail
} from 'api/products/_requests';
import EcomReviewSentimentChart from 'components/charts/EcomReviewSentimentChart';
import React from 'react';

const EcomProductReviews = ({ vendorId }: { vendorId?: string }) => {
  const {
    data: productReviews,
    isLoading,
    isError
  } = useQuery<ProductReviewDetail[]>({
    queryKey: ['product-Review-by-vendor', vendorId],
    queryFn: () => getProductReviewByVendorId(vendorId!),
    enabled: !!vendorId
  });

  if (isLoading) {
    return <div>Loading review data...</div>;
  }

  if (isError) {
    return <div>Failed to load review data.</div>;
  }

  return (
    <div className="me-xl-4">
      <div>
        <h3>Product review behavior</h3>
        <p className="mb-1 text-body-tertiary">
          Breakdown of customer sentiments from reviews
        </p>
      </div>
      <EcomReviewSentimentChart
        data={productReviews}
        height="300px"
        width="100%"
      />
    </div>
  );
};

export default EcomProductReviews;
